import { Button, styled } from "@mui/material";
import { Colors } from "../../Styles/colors";

export const Form = styled('form')`
  text-align:center;
  padding:20px;
  height: 80vh;
  display:flex;
  flex-direction:column;
  margin:auto;
  justify-content: flex-start;
`;

export const StyledButton = styled(Button)(({theme})=>({
  width:'50%',
  alignSelf:'center',
  color:`white`,
  backgroundColor:`${Colors.primary.orange}`,
  fontSize:'16px',
  '&:hover': {
    backgroundColor: `${Colors.primary.blue}`,
  },
  marginBottom:'10px'
}));

export const FormItem = styled('div')`
  padding-bottom:20px;
  width:100%
`;
